<template>
  <footer class="py-4  text-gray-600 bg-center md:bg-cover bg-no-repeat">
    <div class="container mx-auto flex flex-col items-center text-sm">
      <div class="font-bold">Av. Costanera Rafael Obligado 1221, Pabellón 5</div>
      <div>ventas@exponenciar.com.ar / prensa@exponenciar.com.ar</div>
      <div class="text-xs my-2">© 2026 QREventos.com</div>
    </div>
  </footer>

</template>


<script>
import VueScrollTo from 'vue-scrollto';

export default {
  name: 'FooterSection',
  methods: {
    scrollToForm() {
      VueScrollTo.scrollTo('#formulario', 500, {
        easing: 'ease-in-out',
      });
    },
  },
}

</script>